import React, { useContext } from "react";
import SOPendingContent from "./SOPendingContent";
import SalesOrderDetails from "./SalesOrderDetails";
import mainContext from "../context/MainContext/mainContext";

const PendingTab = () => {
  const { id } = useContext(mainContext);

  return <>{id ? <SalesOrderDetails /> : <SOPendingContent />}</>;
};

export default PendingTab;
